export default __webpack_public_path__ + "static/media/humanoidrigging_demo_image.44d9632e.png";